import { useState } from "react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/screens/Landing";
import Assessment from "@/screens/Assessment";
import LeadForm from "@/screens/LeadForm";
import Cinematic from "@/screens/Cinematic";
import Results from "@/screens/Results";
import Admin from "@/screens/Admin";
import PublicAudit from "@/screens/PublicAudit";

export default function App() {
  const path = typeof window !== "undefined" ? window.location.pathname : "/";
  const isAdmin = path.startsWith("/admin");
  const isPublicAudit = path.startsWith("/audit/");

  const [phase, setPhase] = useState("landing");
  const [answers, setAnswers] = useState({});
  const [lead, setLead] = useState({ name: "", email: "", business_name: "", website_url: "" });
  const [result, setResult] = useState(null);

  const restart = () => {
    setPhase("landing");
    setAnswers({});
    setLead({ name: "", email: "", business_name: "", website_url: "" });
    setResult(null);
  };

  const renderRoute = () => {
    if (isAdmin) return <Admin />;
    if (isPublicAudit) return <PublicAudit />;
    return (
      <>
        {phase === "landing" && <Landing onStart={() => setPhase("assessment")} />}
        {phase === "assessment" && (
          <Assessment
            answers={answers}
            setAnswers={setAnswers}
            onComplete={() => setPhase("lead")}
            onExit={() => setPhase("landing")}
          />
        )}
        {phase === "lead" && (
          <LeadForm lead={lead} setLead={setLead} onSubmit={() => setPhase("analyzing")} />
        )}
        {phase === "analyzing" && (
          <Cinematic
            answers={answers}
            lead={lead}
            onDone={(r) => { setResult(r); setPhase("results"); }}
            onError={() => setPhase("lead")}
          />
        )}
        {phase === "results" && result && (
          <Results result={result} lead={lead} onRestart={restart} />
        )}
      </>
    );
  };

  return (
    <div className="min-h-screen bg-[#F9F9F6] text-[#111] grain relative">
      {renderRoute()}
      <Toaster position="bottom-right" />
    </div>
  );
}
